import { createTheme } from "@mui/material/styles";

const closedDrawerWidth = "90px";

export const DrawerItemsTheme = ({
    theme,
    openMenu,
    overflow,
    openedDrawerWidth,
    listHeight,
    showCompanySettingsModal,
    openUserDialog,
    mainNavBarHeight,
    isFreeTrial = false,
    isMbxAdminLoggedIn = false
}) =>
    createTheme({
        components: {
            MuiDrawer: {
                styleOverrides: {
                    root: {
                        position: "fixed",
                        backgroundColor: theme.palette.background.paper,
                        zIndex: 3,
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                        textWrap: "nowrap",
                        "& .MuiPaper-root": {
                            top:
                                (!isFreeTrial || isMbxAdminLoggedIn) &&
                                mainNavBarHeight,
                            width: openMenu
                                ? openedDrawerWidth
                                : closedDrawerWidth,
                            transition: openMenu
                                ? theme.transitions.create(["width"], {
                                      easing: theme.transitions.easing.sharp,
                                      duration:
                                          theme.transitions.duration
                                              .enteringScreen
                                  })
                                : showCompanySettingsModal || openUserDialog
                                  ? "none"
                                  : theme.transitions.create(["width"], {
                                        easing: theme.transitions.easing.sharp,
                                        duration:
                                            theme.transitions.duration
                                                .leavingScreen
                                    })
                        }
                    },
                    paper: {
                        height: "100%",
                        border: "none",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)"
                    }
                }
            },
            MuiList: {
                styleOverrides: {
                    root: {
                        position: "fixed",
                        overflow: overflow,
                        width: openMenu ? openedDrawerWidth : closedDrawerWidth,
                        transition: openMenu
                            ? theme.transitions.create(
                                  ["width", "background-color"],
                                  {
                                      easing: theme.transitions.easing.sharp,
                                      duration:
                                          theme.transitions.duration
                                              .enteringScreen
                                  }
                              )
                            : showCompanySettingsModal || openUserDialog
                              ? "none"
                              : theme.transitions.create(
                                    ["width", "background-color"],
                                    {
                                        easing: theme.transitions.easing.sharp,
                                        duration:
                                            theme.transitions.duration
                                                .leavingScreen
                                    }
                                ),
                        height: listHeight,
                        display: "flex",
                        flexDirection: "column",
                        padding: "18px 0px",
                        paddingTop:
                            isFreeTrial && !isMbxAdminLoggedIn && "162px"
                    }
                }
            },
            MuiListItem: {
                styleOverrides: {
                    root: {
                        height: "100%",
                        maxHeight: "54px"
                    }
                }
            },
            MuiListItemButton: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        /* maxHeight: isFreeTrial ? "40px" : "54px", */
                        minHeight: isFreeTrial ? "40px" : "42px",
                        maxHeight: "54px",
                        /* minHeight:  "42px", */
                        height: "100%",
                        padding: openMenu ? "0px 30px 0px 33px" : "0px 33px",
                        justifyContent: "initial",
                        "& .MuiTypography-root": {
                            fontSize: "0.875rem"
                        },
                        "&.Mui-selected": {
                            backgroundColor: theme.palette.primary.main,
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
                            "& .MuiListItemIcon-root": {
                                color: "white"
                            },
                            "& .MuiListItemText-root": {
                                color: "white"
                            },
                            "&:hover": {
                                backgroundColor: theme.palette.primary.main
                            }
                        },
                        "&.Mui-focusVisible": {
                            backgroundColor: "white"
                        },
                        "&:hover": {
                            backgroundColor: theme.palette.primary.medium
                        },
                        variants: [
                            {
                                props: { variant: "disabled-styling" },
                                style: {
                                    opacity: 0.5,
                                    "&:hover": {
                                        backgroundColor:
                                            theme.palette.text.disabled,
                                        "& .MuiListItemIcon-root": {
                                            color: "white"
                                        },
                                        "& .MuiListItemText-root": {
                                            color: "white"
                                        }
                                    }
                                }
                            },
                            {
                                props: { variant: "submenu" },
                                style: {
                                    "& .MuiTypography-root": {
                                        display: "flex",
                                        color: theme.palette.text.main
                                    },
                                    "& .MuiSvgIcon-root": {
                                        color: theme.palette.text.main
                                    },
                                    "&:hover": {
                                        backgroundColor:
                                            theme.palette.primary.medium
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        color: theme.palette.text.main,
                        minWidth: 0,
                        justifyContent: "center",
                        marginRight: openMenu ? "18px" : "auto"
                    }
                }
            },
            MuiListItemText: {
                styleOverrides: {
                    root: {
                        display: openMenu ? "auto" : "none",
                        color: theme.palette.text.main
                    },
                    primary: {
                        fontWeight: 700
                    }
                }
            }
        }
    });
